import { useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Input } from "../components/atoms/Input/Input";
import { Button } from "../components/atoms/Button/Button";
import { DialogHeader } from "../components/atoms/Dialog/Dialog";

/**
 * パスワードをお忘れの場合ページ
 *
 * 入力フォーム → 発行完了メッセージ を同一ページ内で切り替える。
 */
const ForgotPasswordPage = () => {
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [isCompleted, setIsCompleted] = useState(false);

    const navigate = useNavigate();
    const isFormFilled = email.length > 0 && name.length > 0;

    const handleSubmit = useCallback((e: React.FormEvent) => {
        e.preventDefault();

        // TODO: 仮パスワード発行APIを呼び出す
        setIsCompleted(true);
    }, []);

    return (
        <div className="min-h-svh flex items-center justify-center bg-[#EEF6F4]">
            <div className="w-full max-w-2xl bg-white rounded-2xl shadow-lg">
                {isCompleted ? (
                    /* ── 発行完了 ── */
                    <div className="space-y-6 px-8 py-8">
                        <h2 className="text-lg font-semibold text-gray-900">
                            仮パスワードの発行完了
                        </h2>

                        <div className="text-sm text-gray-700 space-y-4">
                            <p>
                                入力したメールアドレスにパスワード再設定画面のURLと仮パスワードを送付いたします。
                                <br />
                                パスワード再設定画面で仮パスワードを入力し、パスワードの再設定を行ってください。
                            </p>
                            <p>
                                メールが届くまでにお時間がかかる場合がございます。
                                <br />
                                2〜3時間たってもメールが届かない場合は、メールアドレスと氏名をご確認のうえ、もう一度仮パスワードの発行を行ってください。
                            </p>
                        </div>

                        <div className="pt-4">
                            <Link
                                to="/login"
                                className="text-sm text-brand-500 hover:text-brand-600 underline transition-colors duration-200"
                            >
                                ログイン画面に戻る
                            </Link>
                        </div>
                    </div>
                ) : (
                    /* ── 入力フォーム ── */
                    <div>
                        <DialogHeader
                            title="パスワードをお忘れの場合"
                            onClose={() => navigate("/login")}
                            className="rounded-t-2xl"
                        />

                        <div className="px-5 py-4">
                        <p className="text-sm text-gray-900 mb-12">
                            メールアドレスと氏名を入力して、仮パスワードの発行を行ってください。
                        </p>

                        <form onSubmit={handleSubmit} className="space-y-5">
                            {/* メールアドレス */}
                            <Input
                                label="メールアドレス"
                                placeholder="メールアドレスを入力"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                autoComplete="email"
                            />

                            {/* 氏名 */}
                            <div>
                                <Input
                                    label="氏名"
                                    placeholder="氏名を入力"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    autoComplete="name"
                                />

                                {/* 重要メッセージ */}
                                <p className="mt-3 text-sm text-error-500 text-center">
                                    【重要】仮パスワードを発行すると、お忘れになったパスワードは利用できなくなります。
                                </p>
                            </div>

                            {/* 発行ボタン */}
                            <div className="flex justify-center pt-12 pb-8">
                                <Button
                                    type="submit"
                                    variant={isFormFilled ? "primary" : "secondary"}
                                    size="lg"
                                    disabled={!isFormFilled}
                                    className="w-3/5"
                                >
                                    仮パスワードを発行する
                                </Button>
                            </div>
                        </form>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ForgotPasswordPage;
